<template>
    <div class="chaton-whatsappchat-responsive">
        <div class="chaton-userinfo">
            <div class="chaton-userinfo_title">
                <a href="javascript:void(0);" @click.prevent="backToTabList()" class="chaton-backtolist">
                    <i class="chatonicon chaton-chevron-left"></i>
                </a>
                <figure class="chaton-userinfo_title_img" :class="{'chaton-notavailable' : !chatInfo.isOnline}">
                    <img :src="chatInfo.userAvatar ? chatInfo.userAvatar : defaultAvatar" :alt="chatInfo.userName" />
                    <span class="chaton-userstatus" :class="chatInfo.isOnline ? 'online' : 'offline'"></span>
                </figure>
                <div class="chaton-userinfo_title_name">
                    <h3>{{chatInfo.userName | capitalize }}</h3>
                </div>
            </div>
        </div> 
        <div class="chaton-view-messages" :style="chatBackround">
            <div :id="'message-wrap_' + chatInfo.chatId" class="chaton-messagewrap">
                <div v-if="isLoading" class="chaton-msgautotyper"><img :src="typingIcon" :alt="TRANS.whatsapp_loading_msg"></div>
                <div v-else class="chaton-messages">
                    <div class="chaton-message" v-linkified> 
                        {{chatInfo.isOnline ? chatInfo.userDefaultMessage : chatInfo.userOfflineMessage}}
                        <span class="chaton-message_time">{{currentTime}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="chaton-replay" :class="{'chaton-replay_disable' : isLoading }">
            <div class="chaton-replay_content">
                <send-text-message />
                <span><a v-if="getMessageInput" @click.prevent="sendTextMessage()" href="javascript:void(0);" class="chaton-sendmsg"><i class="chatonicon chaton-send"></i></a></span>
            </div>
        </div>
    </div>
</template>

<script>
    import AVATAR from "../resources/avatar.png";
    import moment from "moment";
    import SendTextMessage from "../SendTextMessage/SendTextMessage.vue";
    const CHATON_SETTINGS           = window.chaton_scripts_vars.chatSetting;
    export default {
        name : 'ResponsiveChatBox',
        components : {
            SendTextMessage,
        },
        data(){
            return {
                typingIcon          : CHATON_SETTINGS.typingIcon,
                defaultAvatar       : AVATAR,
                currentTime         : moment().format("LT"),
                whatsappBackground  : CHATON_SETTINGS.chatonBackground,
            }
        },
        computed:{
            chatBackround(){
                if(this.whatsappBackground){
                    return { backgroundImage : `url(${this.whatsappBackground})` }
                }
                return { backgroundColor : '#F7F1E7' };
            },
            chatInfo(){
                return this.$store.getters.getChatInfo;
            },
            getMessageInput(){
                return this.$store.getters.getMessageInput;
            },
        },
        watch:{
            chatInfo(newVal, oldVal){
                if(newVal.chatId != oldVal.chatId){
                    if(newVal.isOnline){
                        this.isLoading = true;
                        this.loadingMessage();
                    }
                }
            }
        },
        methods : {
            sendTextMessage(){
                document.getElementById(`input-text-message-${this.chatInfo.chatId}`).focus();
                this.$root.$emit('openWhatsapp', {chatId : this.chatInfo.chatId});
            },
            backToTabList(){
                let data = { isEmptyView : true, isOpenMessagesScr : false}
                this.$store.dispatch('toggleMessagesScr', data)
                this.$store.commit('updateChatInfo', {})
            },
            loadingMessage(){
                setTimeout(()=>{
                    this.isLoading = false;
                },2000);
            }
        },
        created(){
            if(this.chatInfo.isOnline){
                this.isLoading = true;
                this.loadingMessage()
            }
        }
    }
</script>

<style scoped>
.chaton-whatsappchat-responsive{
    height: 100%;    
    display: flex;
    flex-direction: column;
}
.chaton-whatsappchat-responsive .chaton-view-messages{
    flex: auto;
    height: auto;
    background-size: cover;
    background-position: center;
    justify-content: flex-start;
    background-repeat: no-repeat;
}
.chaton-whatsappchat-responsive .chaton-messagewrap{
    height: 100%;
    padding: 30px;
    overflow: auto;
}
.chaton-whatsappside-responsive .chaton-whatsappchat-responsive .chaton-messages{
    padding: 0;
}
.chaton-whatsappside-responsive .chaton-whatsappchat-responsive .chaton-message{
    max-width: 100%; 
    font-size: 15px;
    line-height: 22px;
    padding: 20px 20px 14px;
}
.chaton-whatsappchat-responsive .chaton-message > span{
    margin: 0;
}
.chaton-whatsappchat-responsive .chaton-userinfo{
    box-shadow: none;
    padding: 15px 20px;
    background: var(--themewhatsappcolor);
}
.chaton-userinfo_title {
  display: flex;
  align-items: center;
}
.chaton-whatsappsidepopup .chaton-backtolist{
  display: block;
}
.chaton-backtolist {
    font-size: 22px;
    color: #000;
    margin-right: 15px;
    line-height: 0.8;
    display: none;
    text-decoration: none;
}
.chaton-whatsappchat-responsive .chaton-backtolist {
    color: #fff;
}
.chaton-userinfo_title_img {
    flex: none;
    margin: 0 15px 0 0 !important;
    max-width: 50px;
    position: relative;
}
.chaton-whatsappchat-responsive .chaton-userinfo_title_img{
    margin: 0 10px 0 0 !important;
}
.chaton-whatsappchat-responsive .chaton-userinfo_title_img.chaton-notavailable {
    filter: grayscale(1);
}
.chaton-whatsappchat-responsive .chaton-userinfo_title_name h3{
    color: #fff;
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    font-family: var(--primchatfont);
    margin-bottom: 0;
    margin-top: 0;
}
.chaton-whatsappchat-responsive .chaton-userinfo_title_img img{
    height: 30px;
    max-width: 30px;
    display: block;
    width: 100%;
    object-fit: cover;
    border-radius: 50%;
}
.chaton-whatsappchat-responsive .chaton-userstatus{
    right: -3px;
    bottom: -3px;
    border-radius: 50%;
    position: absolute;
    border: 3px solid var(--themewhatsappcolor);
}
.chaton-whatsappchat-responsive .chaton-userstatus:before{
    margin: 0;
}
.chaton-whatsappchat-responsive .chaton-replay_msg{
    padding: 0;
}
.chaton-userinfo_title_name {
    display: flex;
    flex-wrap: wrap;
}
.chaton-replay_content {
    display: flex;
    align-items: center;
    width: 100%;
}
.chaton-view-messages {
    height: calc(100vh - 198px);
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    overflow: hidden;
}
</style>